import { MatchedText } from './asyncSelectStyle';

/**
 * Format label to bold the text matched.
 */
export const formatLabel = (label: string, matchedText: string, isNew = false) => {
  if (!label || isNew) {
    return [label];
  }

  const uniqueReplacement = Date.now().toString();
  const regex = new RegExp(`(${encodeURI(matchedText)})`, 'gi');

  return label
    .replace(regex, uniqueReplacement + '$1' + uniqueReplacement)
    .split(uniqueReplacement)
    .map((wordPart) =>
      wordPart.toLowerCase() === matchedText?.toLowerCase() ? (
        <MatchedText>{wordPart}</MatchedText>
      ) : (
        wordPart
      )
    );
};
